import { DEV } from 'esm-env';
import { queue_micro_task } from './task.js';
import { register_style } from '../dev/css.js';

/**
 *
 *
 */
export function append_styles(anchor, css) {
	/*                                                                                                        */
	queue_micro_task(() => {
		var root = anchor.getRootNode();

		var target = /*                     */ (root).host
			? /*                     */ (root)
			: /*                   */ (root).head ?? /*                   */ (root.ownerDocument).head;

		/*                                                                                                             */
		/*                                                                                                            */
		if (!target.querySelector('#' + css.hash)) {
			const style = document.createElement('style');
			style.id = css.hash;
			style.textContent = css.code;

			target.appendChild(style);

			if (DEV) {
				register_style(css.hash, style);
			}
		}
	});
}
